import { useState } from 'react';
import { Link } from 'react-router-dom';
import { footerLinks } from '@/mocks/homepage';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubscribeStatus('success');
    setEmail('');
  };

  return (
    <footer className="bg-foreground-950 mt-20 mx-4 md:mx-6 mb-4 md:mb-6 rounded-2xl overflow-hidden">
      <div className="px-6 md:px-12 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-12">
          <div>
            <Link to="/" className="inline-block mb-5">
              <span className="text-2xl font-bold font-heading text-background-50 tracking-tight whitespace-nowrap">
                韩漫在线
              </span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-md">
              韩漫在线 - 韩国漫画免费阅读平台，每日更新，海量资源，高清画质，随时随地畅享阅读乐趣。
            </p>
          </div>
          <div className="text-right hidden md:block">
            <p className="text-foreground-400 text-sm leading-relaxed">
              探索韩国漫画的无限世界
              <br />
              随时随地畅享阅读
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-14">
          <div>
            <h4 className="text-background-50 text-sm font-semibold mb-4 whitespace-nowrap">漫画分类</h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.categories.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-foreground-400 text-sm hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-background-50 text-sm font-semibold mb-4 whitespace-nowrap">快速链接</h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.quickLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-foreground-400 text-sm hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-background-50 text-sm font-semibold mb-4 whitespace-nowrap">帮助支持</h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.support.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-foreground-400 text-sm hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:text-right">
            <p className="text-background-50 text-2xl font-heading font-bold mb-2 whitespace-nowrap">
              &copy; {new Date().getFullYear()} 韩漫在线
            </p>
            <p className="text-foreground-500 text-sm mb-4 whitespace-nowrap">All rights reserved.</p>
            <div className="flex gap-4 md:justify-end">
              <a href="#" className="text-foreground-400 text-sm hover:text-background-50 transition-colors underline whitespace-nowrap" rel="nofollow">微博</a>
              <a href="#" className="text-foreground-400 text-sm hover:text-background-50 transition-colors underline whitespace-nowrap" rel="nofollow">微信</a>
              <a href="#" className="text-foreground-400 text-sm hover:text-background-50 transition-colors underline whitespace-nowrap" rel="nofollow">QQ</a>
              <a href="#" className="text-foreground-400 text-sm hover:text-background-50 transition-colors underline whitespace-nowrap" rel="nofollow">哔哩哔哩</a>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center pt-8 border-t border-foreground-800/40">
          <div className="md:col-span-1">
            <img
              src="https://readdy.ai/api/search-image?query=Cozy%20reading%20scene%20with%20smartphone%20displaying%20Korean%20webtoon%20comic%2C%20warm%20indoor%20lighting%2C%20minimalist%20interior%20with%20plant%20and%20soft%20textiles%2C%20relaxed%20atmosphere%2C%20clean%20composition%2C%20modern%20lifestyle%20photography&width=400&height=280&seq=footer-reading-01&orientation=landscape"
              alt="韩漫在线阅读场景"
              title="韩漫在线阅读场景"
              className="w-full h-44 object-cover rounded-xl"
            />
          </div>
          <div className="md:col-span-1">
            <p className="text-foreground-200 text-2xl font-heading font-bold leading-relaxed">
              随时随地
              <br />
              畅享韩漫
              <br />
              无限精彩
            </p>
          </div>
          <div className="md:col-span-1">
            <p className="text-foreground-400 text-sm mb-3 leading-relaxed">
              获取最新漫画更新通知
              <br />
              和个性化推荐
            </p>
            <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入您的邮箱"
                className="flex-1 px-4 py-2.5 bg-foreground-900 border border-foreground-700 rounded-full text-sm text-background-50 placeholder-foreground-500 outline-none focus:border-primary-500 transition-colors"
              />
              <div className="relative" style={{ display: 'none' }}>
                <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
              <button
                type="submit"
                className="px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-1.5"
              >
                订阅
                <i className="ri-arrow-right-line" />
              </button>
            </form>
            {subscribeStatus === 'success' && (
              <p className="text-green-400 text-xs mt-2">订阅成功！感谢您的关注。</p>
            )}
            {subscribeStatus === 'error' && (
              <p className="text-red-400 text-xs mt-2">订阅失败，请稍后重试。</p>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
}